import {
  Drawer,
  DrawerProps,
  message
} from 'antd';
import { MediumDrawerWidth } from '../../../../constants/drawer';
import { CGMDeviceFormContainer, CGMDeviceFormContainerProps } from '../../container/CGMDeviceDrawerBodyContainer/CGMDeviceFormContainer';

import './CGMDeviceDrawerComponent.scss';

export interface CGMDeviceDrawerComponentProps extends DrawerProps {
  patientId: string;
  onSave?: CGMDeviceFormContainerProps['onSave'];
  onSubmit?: () => void;
  onClose?: () => void;
}

export const CGMDeviceDrawerComponent = ({
  patientId,
  title = 'Choose Device',
  open,
  onSave,
  onSubmit,
  onClose,
}: CGMDeviceDrawerComponentProps) => {
  const handleClose = () => {
    onClose?.();
  };

  const handleSubmit = () => {
    message.success('CGM device updated successfully.');
    onSubmit?.();
    handleClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      width={MediumDrawerWidth}
      className="cgm-device-drawer"
      forceRender={false}
      maskClosable={false}
      destroyOnClose
    >
      <div className="cgm-device-drawer__body">
        <CGMDeviceFormContainer
          patientId={patientId}
          onSave={onSave}
          onSubmit={handleSubmit}
          onCancel={handleClose}
        />
      </div>
    </Drawer>
  );
};
